import { Box } from "@mui/material";
import React, { useState } from "react";
import { Navigate } from "react-router-dom";

import Reports from "./reports";
import PriceListMaster from "../features/ordermanagement/pricelist/PriceListIndex";
import HSNMaster from "../features/ordermanagement/hsn/HSNindex";
import BulkOrderUpload from "../features/ordermanagement/bulkorderupload/uploadorderindex";

import ReportsPages from "../features/ordermanagement/reports/ReportsPages";
import OrderList from "../features/ordermanagement/orderentry/OrderList";
import CoTODM from "../features/ordermanagement/confirmationToDeckleMatching";
import OrderManagementMenu from "../features/ordermanagement/OrderManagement-Menu";

const SalesIndex = () => {
    const [activePage, setActivePage] = useState('ViewMainPage');

    const SetActive = (page) => {
        setActivePage(page);
    }
    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }
    return (
        <Box position="relative">
            {activePage === "ViewMainPage" && (<OrderManagementMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />)}            
            {activePage === "Order Management" && (                
                <OrderList handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {activePage === "ConfirmationOrder" && (
                <CoTODM handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "SalesReports" && (
                <Reports handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "PriceList" && (
                <PriceListMaster handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {activePage === "HSNMaster" && (
                <HSNMaster handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "BulkOrderUpload" && (
                <BulkOrderUpload handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {activePage === "ReportTemplates" && (
                <ReportsPages handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            
        </Box>

    );

};
export default SalesIndex;